export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lotes"])},
          "new_harvested_batch_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo lote"])},
          "total_number_harvested_batches": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lotes"])},
          "download_harvest_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reporte de cosecha"])},
          "download_packing_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reporte de empaque"])},
          "download_consolidated_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reporte consolidado"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of processes"])}
        }
      }
    }
  })
}